import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { handleErrorResponse } from "../../apis";

export const getFacilityShipments = createAsyncThunk('getFacilityShipments', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/get-facility-shipments`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getShipmentPackingFile = createAsyncThunk('getShipmentPackingFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/get-shipment-packing-file/${data?.shipment_id}`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'packing_file.csv'; // Default filename if none is found
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadIndiaInvoice = createAsyncThunk('downloadIndiaInvoice', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/get-shipment-stn/${data?.shipment_id}/${data?.file_type}`
    try {
        // let response = await axios.post(URL, data)
        let response;
        let filename; // Default filename if none is found

        if (data?.file_type === 'excel') {
            let bodyFormData = new FormData();
            Object.entries(data)?.forEach(([key, value]) => {
                bodyFormData.append(key, value)
            })
            response = await axios.post(URL, bodyFormData, { headers: { "Content-Type": "multipart/form-data" }, 'responseType': 'arraybuffer'})
            filename = 'invoice.xlsx';
        } else {
            response = await axios.post(URL, data);
            filename = 'invoice.pdf';
        }
        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
                filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

// v1/erp/india-supply/vendor/get-shipment-packing-file/<shipment_id>
